import { Edit, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";

const EditAdvancedSpecializationSpecialist = () => {
  return (
    <Edit
      title="Редактиране на ВСД Специализант"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm isEdit />
      </SimpleForm>
    </Edit>
  );
};

export default EditAdvancedSpecializationSpecialist;
